import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Session is carried by an httpOnly cookie set by the backend; send it with every request.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/portal") || path.startsWith("/admin")) {
        localStorage.removeItem("tactis_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
